import createVueApp from '../../shared/vue/create-app';
import shared from '../../shared';
import initCustomInputsComponents from '../../components/inputs/custom-inputs';
import initCustomControls from '../../components/custom-controls';
import {initLoginComponents} from '../../components';
import initCommentsComponents from '../../components/comments';
import initSocialsComponent from '../../components/socials/jssocials';
import openPreviewMixin from '../../shared/vue/openPreviewMixin';

const initBlogPage = (opts) => {
    const app = createVueApp({ // NOSONAR
        mixins: [openPreviewMixin],
        data() {
            return {
                isBuyLocationMode: true,
            };
        },
        methods: {
            openDetails(url) {
                window.location.href = url;
            },
        },
    });

    initCustomInputsComponents(app);
    initCustomControls(app);
    initLoginComponents(app);
    initCommentsComponents(app);
    initSocialsComponent(app);

    app.mount('#app');
};

export {
    shared,
    initBlogPage,
};
